import Vue from 'vue'
import wx from 'weixin-js-sdk'

Vue.prototype.$wx = wx

export default wx
